import { Box, Fade } from '@mui/material';
import { useState } from 'react';
import ExportConfigurationSelection from 'pages/importExportConfiguration/components/exportConfiguration/ExportConfigurationSelection';
import ExportConfigurationDetails from 'pages/importExportConfiguration/components/exportConfiguration/ExportConfigurationDetails';
import { useGetAssistantsQuery } from 'services/assistantApi';
import { useGetPromptsQuery } from 'services/promptApi';
import { useGetScriptsQuery } from 'services/scriptApi';

export default function ExportConfiguration() {
  const { data: assistants = [] } = useGetAssistantsQuery();
  const { data: prompts = [] } = useGetPromptsQuery();
  const { data: scripts = [] } = useGetScriptsQuery();

  const [selectedAssistants, setSelectedAssistants] = useState([]);
  const [selectedPrompts, setSelectedPrompts] = useState([]);
  const [selectedScripts, setSelectedScripts] = useState([]);

  // Filter selected items based on IDs
  const selectedAssistantObjects = assistants.filter((a) => selectedAssistants.includes(a.id));
  const selectedPromptObjects = prompts.filter((p) => selectedPrompts.includes(p.id));
  const selectedScriptObjects = scripts.filter((s) => selectedScripts.includes(s.code));

  const handleReset = () => {
    setSelectedAssistants([]);
    setSelectedPrompts([]);
    setSelectedScripts([]);
  };

  return (
    <Fade in timeout={(1000, 500)}>
      <Box sx={{ display: 'flex', flex: 1, height: '100%' }}>
        <Box sx={{ display: 'flex', flex: 0.6 }}>
          <ExportConfigurationSelection
            selectedAssistants={selectedAssistants}
            setSelectedAssistants={setSelectedAssistants}
            selectedPrompts={selectedPrompts}
            setSelectedPrompts={setSelectedPrompts}
            selectedScripts={selectedScripts}
            setSelectedScripts={setSelectedScripts}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flex: 0.4,
            marginLeft: 2.5,
            position: 'sticky',
            height: '300px',
            top: '10px'
          }}
        >
          <ExportConfigurationDetails
            assistants={selectedAssistantObjects}
            prompts={selectedPromptObjects}
            scripts={selectedScriptObjects}
            onReset={handleReset}
          />
        </Box>
      </Box>
    </Fade>
  );
}
